import { defineStore } from 'pinia'

export const useMenuStore = defineStore('menu', () => {
  const menu = ref({ primary: [], secondary: [] })

  return {
    menu,
  }
})
